import { translate } from '@/services/translations'
import { currencyFormat } from '@/services/utils'
const $gettext = translate.gettext.bind(translate)

const variables = [
  {
    name: 'cv1',
    template: '{{cv1}}',
    default: $gettext('my organization'),
  },
  {
    name: 'cv2',
    template: '{{cv2}}',
    default: `${$gettext('colleagues')}`,
  },
  {
    name: 'cv3',
    template: '{{cv3}}',
    default: $gettext('employee'),
  },
  {
    name: 'cv4',
    template: '{{cv4}}',
    default: $gettext('The Workers Lab, the Grant Circle’s nonprofit fiscal sponsor'),
  },
  {
    name: 'cv7',
    template: '{{cv7}}',
    default: $gettext('working for'),
  },
  {
    name: 'cv8',
    template: '{{cv8}}',
    default: $gettext('the past 12 months'),
  },
]
function orgVars(org, lang) {
  return [
    {
      template: '%{organization.name}',
      value: org.name,
    },
    {
      template: '%{organization.grantLimit}',
      value: currencyFormat(org.grantLimit, lang, true),
    },
    {
      template: '%{organization.supportEmail}',
      value: org.supportEmail,
    },
    {
      template: '%{organization.rollingGrantDuration}',
      value: org.rollingGrantDuration,
    },
  ]
}

export function customVariableValue(text, orgCVs) {
  let output = text
  for (let variable of variables) {
    const defaultVar = variable.default
    let replacement = orgCVs[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }
  return output
}

export function customVariablesFilter(text, orgCVs, _lang) {
  let output = text
  for (let variable of variables) {
    const defaultVar = variable.default
    let replacement = orgCVs[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }
  return output
}

export function customVariablesFromBackendValue(text, orgCVs) {
  let output = text
  for (let variable of variables) {
    const defaultVar = variable.default
    let replacement = orgCVs[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }
  return output
}

export function customVariablesFromBackendTranslationFilter(text, orgCVs, _lang) {
  let output = text
  for (let variable of variables) {
    const defaultVar = variable.default
    let replacement = orgCVs[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }
  return output
}

export function getDefaultForCustomVariable(varName) {
  for (let variable of variables) {
    if (variable.name === varName) {
      return variable.default
    }
  }
  throw Error('Invalid argument: varName at getDefault()')
}

export function getVariableReplacement(text, org, lang) {
  let output = text

  for (let variable of variables) {
    const defaultVar = variable.default
    let replacement = org.customVariables[variable.name] || defaultVar
    output = output.split(variable.template).join(replacement)
  }

  for (let orgVar of orgVars(org, lang.replace('_', '-'))) {
    output = output.replaceAll(orgVar['template'], orgVar['value'])
  }
  return output
}
